import React, { useMemo } from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';

import { getPlateSizeString, getPlateTypeAndSizeString, getPlateTypeString } from '@paragon/material-lists';

import { AssemblyPlatePart } from '../../../../store/selectors/assemblyPartsUtilities';
import { PropertyTable, zebraStripingSx } from '../../subpanels/properties/PropertyTable';

interface AssemblyPlatePartsProps {
  readonly assemblyPlateParts: readonly AssemblyPlatePart[];
  readonly showTrussQuantity?: boolean;
}

export function AssemblyPlateParts({ assemblyPlateParts, showTrussQuantity }: AssemblyPlatePartsProps) {
  const showQuantitiesPerPlyColumn = useMemo(
    () => assemblyPlateParts.some((platePart) => platePart.quantityPerPly !== platePart.quantityPerTruss),
    [assemblyPlateParts],
  );
  const columns = useMemo(
    () =>
      showTrussQuantity
        ? showQuantitiesPerPlyColumn
          ? ['Size', 'Type', 'Ply Quantity', 'Truss Quantity', 'Overall Quantity']
          : ['Size', 'Type', 'Truss Quantity', 'Overall Quantity']
        : ['Size', 'Type', 'Quantity'],
    [showQuantitiesPerPlyColumn, showTrussQuantity],
  );

  return (
    <PropertyTable columns={columns}>
      {assemblyPlateParts.map((platePart) => (
        <TableRow key={getPlateTypeAndSizeString(platePart)} sx={zebraStripingSx}>
          <TableCell>
            <Typography variant="h6">{getPlateSizeString(platePart)}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="h6">
              {getPlateTypeString(platePart.plateType, platePart.tangiblePlateTypesForComboPlateType)}
            </Typography>
          </TableCell>
          {showTrussQuantity && showQuantitiesPerPlyColumn ? (
            <TableCell>
              <Typography variant="h6">{platePart.quantityPerPly}</Typography>
            </TableCell>
          ) : null}
          {showTrussQuantity && (
            <TableCell>
              <Typography variant="h6">{platePart.quantityPerTruss}</Typography>
            </TableCell>
          )}
          <TableCell>
            <Typography variant="h6">{platePart.overallQuantity}</Typography>
          </TableCell>
        </TableRow>
      ))}
    </PropertyTable>
  );
}
